function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.80001H2.4H13.6",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9 3.8C12.9 3.4134 12.5866 3.1 12.2 3.1C11.8134 3.1 11.5 3.4134 11.5 3.8H12.9ZM3.10002 3.8C3.10002 3.4134 2.78662 3.1 2.40002 3.1C2.01343 3.1 1.70002 3.4134 1.70002 3.8H3.10002ZM3.80002 3.8C3.80002 4.1866 4.11343 4.5 4.50002 4.5C4.88662 4.5 5.20002 4.1866 5.20002 3.8H3.80002ZM9.40002 3.8C9.40002 4.1866 9.71342 4.5 10.1 4.5C10.4866 4.5 10.8 4.1866 10.8 3.8H9.40002ZM11.5 3.8V13.6H12.9V3.8H11.5ZM11.5 13.6C11.5 13.9866 11.1866 14.3 10.8 14.3V15.7C11.9598 15.7 12.9 14.7598 12.9 13.6H11.5ZM10.8 14.3H3.80002V15.7H10.8V14.3ZM3.80002 14.3C3.41342 14.3 3.10002 13.9866 3.10002 13.6H1.70002C1.70002 14.7598 2.64023 15.7 3.80002 15.7V14.3ZM3.10002 13.6V3.8H1.70002V13.6H3.10002ZM5.20002 3.8V2.4H3.80002V3.8H5.20002ZM5.20002 2.4C5.20002 2.0134 5.51342 1.7 5.90002 1.7V0.3C4.74023 0.3 3.80002 1.2402 3.80002 2.4H5.20002ZM5.90002 1.7H8.70002V0.3H5.90002V1.7ZM8.70002 1.7C9.08662 1.7 9.40002 2.0134 9.40002 2.4H10.8C10.8 1.2402 9.85982 0.3 8.70002 0.3V1.7ZM9.40002 2.4V3.8H10.8V2.4H9.40002Z",
  fill: "#2D3A45"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.89999 7.29999V11.5",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.69998 7.29999V11.5",
  stroke: "#2D3A45",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTrash2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.de72a1d4.svg";
export { ForwardRef as ReactComponent };